// extracted by mini-css-extract-plugin
module.exports = {"container":"empty-state-popover__container___qKUvE","empty-text":"empty-state-popover__empty-text___34m1q"};